import { render, staticRenderFns } from "./Template-01.vue?vue&type=template&id=1e85e78f&scoped=true&"
import script from "./Template-01.vue?vue&type=script&lang=js&"
export * from "./Template-01.vue?vue&type=script&lang=js&"
import style0 from "./Template-01.vue?vue&type=style&index=0&id=1e85e78f&lang=less&scoped=true&"
import style1 from "./Template-01.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85e78f",
  null
  
)

export default component.exports